const selectors = document.querySelectorAll('.js-thumb-selector');
const thumbMain = document.querySelector('.js-thumb-main');

if (selectors.length > 0 && thumbMain) {
  selectors.forEach(selector => {
    // <img>タグの場合にのみ src を取得
    if (selector.tagName === 'IMG') {
      selector.addEventListener('click', (e) => {
        // src 属性と srcset 属性を取得
        let src = selector.src;
        let srcset = selector.srcset;

        // メイン画像の src と srcset 属性を更新
        thumbMain.src = src;
        thumbMain.srcset = srcset;
      });
    }
  });
}